// @flow

import { useEffect } from 'react';
import type { Node } from 'react';
import { useSelector } from 'react-redux';
import { toggleChat } from 'shared_services/riseart/utils/ui';
import { selectLensSearchOpened } from 'shared_services/redux/selectors/gui';

type Props = {
  hideChat: boolean,
  children?: Node,
};

/**
 * UIInit
 *
 * @param {Props} props
 * @returns Node
 */
export function UIInit({ hideChat: hideIntercomChat, children }: Props): Node {
  const isLensOpened = useSelector(selectLensSearchOpened);

  // Toggle Intercom chat
  useEffect(() => {
    toggleChat(hideIntercomChat || isLensOpened);
  }, [hideIntercomChat, isLensOpened]);

  return children || null;
}
